import {DialogTitleProps, IconButton, Typography} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import React from 'react'

import {theme} from '../theme'
import DialogTitle from './DialogTitle'

type Props = DialogTitleProps & {
  onClose: VoidFunction
  littleCloseIcon?: boolean
}

const useTitleClasses = makeStyles({
  root: {
    maxWidth: '90%',
  },
})

const useButtonClasses = makeStyles({
  root: {
    padding: theme.spacing(1),
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(1),
      top: theme.spacing(-1),
    },
  },
  label: {
    width: 32,
    height: 32,
  },
})

const useLittleButtonClasses = makeStyles({
  root: {
    minWidth: 'auto',
    border: `1px solid ${theme.palette.grey.A100}`,
    height: 22,
    width: 22,
    lineHeight: 0,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey.A100,
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(3),
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightBold as any,
    '&:hover': {
      backgroundColor: theme.palette.grey.A200,
      borderColor: theme.palette.grey.A200,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  label: {},
})

const DialogTitleWithClose: React.FC<React.PropsWithChildren<Props>> = ({onClose, littleCloseIcon, ...props}) => {
  const littleButtonClasses = useLittleButtonClasses()
  const buttonClasses = useButtonClasses()
  const titleClasses = useTitleClasses()

  return (
    <DialogTitle disableTypography {...props}>
      <Typography className={titleClasses.root} variant="h6">
        {props.children}
      </Typography>
      <IconButton classes={littleCloseIcon ? littleButtonClasses : buttonClasses} onClick={onClose}>
        ✕
      </IconButton>
    </DialogTitle>
  )
}

export default DialogTitleWithClose
